import { useLocation } from 'react-router-dom';

const PROJECT_PREFIX = /^\/project\/[^/]+/;

// The account pages open inside the project shell when reached from a project, so the sidebar
// keeps showing that project around them
export function accountPath(pathname, page = '') {
  const project = pathname.match(PROJECT_PREFIX);
  return `${project ? project[0] : ''}/account${page}`;
}

export function useAccountPath() {
  const { pathname } = useLocation();
  return (page = '') => accountPath(pathname, page);
}
